import GitMergeIcon from "@redotech/redo-icons/git-merge_filled.svg";
import { memo } from "react";

/**
 * Divider shown in the conversation thread to indicate where tickets were merged.
 * Appears between message groups from different source conversations.
 */
export const MergedTicketDivider = memo(function MergedTicketDivider() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 0,
        width: "100%",
        padding: "4px 0",
      }}
    >
      <div
        style={{
          flex: 1,
          height: 1,
          backgroundColor:
            "var(--redo-colors-border-border-secondary, #e5e5e5)",
        }}
      />
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "2px 10px",
          backgroundColor: "var(--redo-colors-background-bg-primary, white)",
          border:
            "1px solid var(--redo-colors-border-border-secondary, #e5e5e5)",
          borderRadius: "var(--redo-corner-small-radius, 6px)",
          fontSize: "var(--redo-body-xsmall-text-size, 12px)",
          fontWeight: 500,
          color: "var(--redo-colors-text-text-secondary, #424242)",
          whiteSpace: "nowrap",
          flexShrink: 0,
        }}
      >
        <GitMergeIcon
          style={{
            width: 14,
            height: 14,
            flexShrink: 0,
            color: "var(--redo-colors-text-text-secondary, #424242)",
          }}
        />
        Merged ticket
      </div>
      <div
        style={{
          flex: 1,
          height: 1,
          backgroundColor:
            "var(--redo-colors-border-border-secondary, #e5e5e5)",
        }}
      />
    </div>
  );
});
